export const isObject = (variable) => typeof variable === 'object';

export const randomNumber = (min, max) => Math.random() * (max - min) + min;
